import React from 'react';
import { Table, Tag, Typography, Button, Space } from 'antd';
import { exportJobs } from '../../mockData';
import './Export.css';

function ExportReports() {
  const { Title } = Typography;

  const columns = [
    { title: 'Job', dataIndex: 'name', key: 'name' },
    { title: 'Created', dataIndex: 'createdAt', key: 'createdAt' },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (s) => <Tag color={s === 'completed' ? 'green' : s === 'running' ? 'blue' : 'default'}>{s.toUpperCase()}</Tag> },
    {
      title: 'Actions', key: 'actions', render: (_, r) => (
        <Space>
          <Button type="link" onClick={() => console.log('Mock download export', r)} disabled={r.status !== 'completed'}>Download</Button>
          <Button type="link" onClick={() => console.log('Mock cancel export', r)} disabled={r.status !== 'running'} danger>Cancel</Button>
        </Space>
      )
    }
  ];

  return (
    <div className="agency-analytics-export">
      <Title level={3}>Export Reports</Title>
      <Table rowKey="id" columns={columns} dataSource={exportJobs} pagination={false} />
    </div>
  );
}

export default ExportReports;
